import React, { useState } from "react";
import {
  ButtonRow,
  ItemWrapper,
  MainContainer,
  ProjectOptionContainer,
  ProjectOptions,
  Title,
} from "./PhysicalInventoryStyles";
import Button from "../../../../common/Button";
import ContainerSummary from "../../../../internal/parts/InventoryUpdates/ContainerSummary";
import useUpcomingShipmentsUsingPart from "../../../../../utils/hooks/inventory/upcomingShipmentsUsingPart";
import LoadingIcon from "../../../../common/LoadingIcon";
import { ManufacturingItem } from "../../../../../utils/hooks/manfacturingDashboard";
import Checkbox from "../../../../common/Checkbox";
import useDeleteContainers from "../../../../../utils/hooks/inventory/deleteContainer";
import useDeleteEmptyContainer from "../../../../../utils/hooks/inventory/unloadEmptyContainer";
import CalendarItem from "../../../../ManufacturersPanel/Dashboard/CalendarItem";
import { ButtonVariants } from "../../../../common/Button/constants";

export default function DeleteContainer({
  containerBarcode,
  onFinishedEditing,
}: {
  containerBarcode: string;
  onFinishedEditing: () => void;
}) {
  const [selectedShipments, setSelectedShipments] = useState<string[]>([]);
  const { shipmentsPartResponse } = useUpcomingShipmentsUsingPart(
    containerBarcode,
    onFinishedEditing,
  );
  const { deleteContainers } = useDeleteContainers(onFinishedEditing);
  const { deleteEmptyContainer } = useDeleteEmptyContainer(onFinishedEditing);

  const renderContainerSummary = () => (
    <ContainerSummary
      containerBarcode={containerBarcode}
      displayAllocations={false}
    />
  );

  const shipmentIsSelected = (shipmentId: string) => {
    return selectedShipments.includes(shipmentId);
  };

  const updateSelectedShipments = (shipmentId: string) => {
    if (selectedShipments.includes(shipmentId)) {
      const updatedSelectedShipments = selectedShipments.filter(
        (id) => id !== shipmentId,
      );
      setSelectedShipments(updatedSelectedShipments);
    } else {
      setSelectedShipments([...selectedShipments, shipmentId]);
    }
  };
  if (shipmentsPartResponse === null) {
    return <LoadingIcon />;
  }

  return (
    <MainContainer>
      <Title>Delete container</Title>
      {renderContainerSummary()}
      <ProjectOptions>
        {shipmentsPartResponse.shipments.length > 0 ? (
          <>
            <Title>Select project(s) that exhausted container:</Title>
            {shipmentsPartResponse.shipments.map((shipment) => (
              <ProjectOptionContainer key={shipment.shipment_id}>
                <Checkbox
                  checked={shipmentIsSelected(shipment.shipment_id)}
                  onChange={() => updateSelectedShipments(shipment.shipment_id)}
                />
                <ItemWrapper>
                  <CalendarItem
                    manufacturingItem={
                      {
                        board_id: shipment.board.id,
                        shipment_id: shipment.shipment_id,
                        ship_date: shipment.ship_date,
                      } as ManufacturingItem
                    }
                    onClick={() =>
                      updateSelectedShipments(shipment.shipment_id)
                    }
                  />
                </ItemWrapper>
              </ProjectOptionContainer>
            ))}
            <ButtonRow>
              <Button
                centerText
                label={"Spend and discard"}
                onClick={() =>
                  deleteEmptyContainer(containerBarcode, selectedShipments)
                }
              />
            </ButtonRow>
          </>
        ) : (
          <>{"No recent shipments using this part found."}</>
        )}
        <ButtonRow>
          <Button
            centerText
            variant={ButtonVariants.SECONDARY}
            label={
              "Container is lost and should be deleted without spending allocations"
            }
            onClick={() => deleteContainers([containerBarcode])}
          />
        </ButtonRow>
      </ProjectOptions>
    </MainContainer>
  );
}
